import type { BlockInstructionFieldElement } from '../../internal';

export const TOC_STYLES = {
  dotted: 'dotted',
  links: 'links',
  plain: 'plain',
} as const;

export type TocStyle = (typeof TOC_STYLES)[keyof typeof TOC_STYLES];

export interface TOCElement extends BlockInstructionFieldElement {
  instruction: 'TOC';
  options: TOCOptions;
}

/**
 * Options for field type TOC
 */
export interface TOCOptions {
  captionLabel?: string;
  captionLabelIncludingNumbers?: string;
  entriesFromBookmark?: string;
  entryAndPageNumberSeparator?: string;
  headingStyleRange?: string;
  hideTabAndPageNumbersInWebView?: boolean;
  hyperlink?: boolean;
  pageNumbersEntryLevelsRange?: string;
  preserveNewLineInEntries?: boolean;
  preserveTabInEntries?: boolean;
  seqFieldIdentifierForPrefix?: string;
  sequenceAndPageNumbersSeparator?: string;
  stylesWithLevels?: Array<[string, number]>;
  tcFieldIdentifier?: string;
  tcFieldLevelRange?: string;
  useAppliedParagraphOutlineLevel?: boolean;
}
